<template>
  <v-container class="d-grid-center-align user-password__container ">
    <v-alert class="user-password__message" v-model="showAlert" dismissible dense :type="alertType">
      {{ message }}</v-alert
    >
    <v-card class="user-password__form rounded-lg" width="500px">
      <v-card-title class="ml-4"> {{ username }} - Change password </v-card-title>
      <v-card-text>
        <v-form class="user-password-edit">
          <v-text-field
            :rules="passwordValidation"
            v-model="password"
            type="password"
            outlined
            dense
            label="Password"
            class="rounded-lg"
            placeholder="Password"
          ></v-text-field>
          <v-text-field
            :rules="[passwordsMatch]"
            v-model="password_confirmation"
            type="password"
            outlined
            dense
            label="Confirm Password"
            class="rounded-lg"
            placeholder="Confirm Password"
          ></v-text-field>
          <v-btn elevation="0" color="success" @click="updatePassword">Update Password</v-btn>
          <v-btn elevation="0" color="error" @click="$router.back()" class="ml-2">Cancel</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { extractDataAxios, extractErrorMessageAxios, extractValidationErrorsAxios } from "@/httpClient";
const regexValidation = (regex, v, error) => regex.test(v) || error;
const passwordLengthValidation = (v) =>
  regexValidation(/^.{8,20}$/, v, "Password must be at least 8 characters and at most 20 characters.");
const requiredValidation = (v) => !!v || "required";
export default {
  name: "UpdateUserPassword",
  props: {
    id: [Number, String],
  },
  async mounted() {
    this.user = extractDataAxios(await window.axios.get("/api/users/" + this.id));
  },

  data() {
    return {
      password: "",
      password_confirmation: "",
      user: {},
      passwordValidation: [requiredValidation, passwordLengthValidation],
      passwordsMatch: (v) => v === this.password || "Passwords must match",
      showAlert: false,
      alertType: null,
      message: "",
    };
  },
  methods: {
    async updatePassword() {
      try {
        const response = extractDataAxios(
          await window.axios.post(`/api/user/${this.user.id}/update-password`, {
            password: this.password,
            password_confirmation: this.password_confirmation,
          })
        );
        this.message = response;
        this.alertType = "success";
        this.showAlert = true;
      } catch (e) {
        this.message = extractValidationErrorsAxios(e)[0];
        this.alertType = "error";
        this.showAlert = true;
      }
    },
  },
  computed: {
    // passwordsMatch() {
    //   return this.password === this.password_confirmation || "Passwords must match!";
    // },
    username() {
      return this.user.company_name;
    },
  },
};
</script>

<style>
.user-password-edit {
  padding: 15px;
}
.user-password__container {
  grid-template-rows: min-content auto;
}
.user-password__message {
  grid-row: 1 / 2;
}
.user-password__form {
  grid-row: 2 / 3;
}
</style>
